const ReproductionMode = Object.freeze ({
    ASCENDING: 'ASCENDING',
    DESCENDING: 'DESCENDING',
    SIMULTANEOUS: 'SIMULTANEOUS',
    SEQUENTIAL: 'SEQUENTIAL',
    RANDOM: 'RANDOM',
})

export default ReproductionMode;
